import { render, staticRenderFns } from "./PerspectiveForm.vue?vue&type=template&id=34f7c9c3"
import script from "./PerspectiveForm.vue?vue&type=script&lang=js"
export * from "./PerspectiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports